import { KTSVG } from '@helpers/index';
import { LoginForm } from './LoginForm';
import { FormattedMessage } from 'react-intl';
import { LoginWrapper } from './LoginWrapper';

export const Login = () => {
  const logoLink = window.location.host.includes('.de')
    ? 'https://hellobello.de'
    : 'https://hellobello.at';

  return (
    <LoginWrapper>
      <div className="login-logo">
        <a href={logoLink} target="_blank" rel="noopener noreferrer">
          <KTSVG path="/media/logos/logo-green.svg" className="w-full h-auto" />
        </a>
      </div>
      <div className="login-card">
        <h1>
          <span className="login-headline">
            <FormattedMessage id="AUTH.LOGIN.WELCOME" />
          </span>
          {/* Brand name, so it is not translated. */}
          <span className="login-headline-sup">PFOTENPORTAL</span>
        </h1>
        <div className="login-callout">
          <p className="login-callout__text">
            <FormattedMessage
              id="AUTH.LOGIN.SAME_EMAIL"
              values={{ strong: (chunks) => <strong>{chunks}</strong> }}
            />
          </p>
        </div>
        <p className="login-text">
          <FormattedMessage
            id="AUTH.LOGIN.MAGIC_LINK"
            values={{ strong: (chunks) => <strong>{chunks}</strong> }}
          />
        </p>
        {/* <div role="alert" className="login-service-alert">
          <p className="login-service-alert__text">
            Es gibt gerade ein technisches Problem. Wir arbeiten mit Hochdruck an einer Lösung.
            Danke für euer Verständnis!
          </p>
        </div> */}
        <LoginForm />
        <div className="login-bottom-links">
          <span className="login-bottom-links__question">
            <FormattedMessage id="AUTH.LOGIN.NO_ACCOUNT_QUESTION" />
          </span>
          {/* Hardcoded .de while logoLink above derives its host from window.location,
              so this CTA sends .at and .ch visitors to the German storefront. */}
          <a href="https://www.hellobello.de/pages/futter" className="login-bottom-links__cta">
            <FormattedMessage id="AUTH.LOGIN.NO_ACCOUNT_CTA" />
          </a>
        </div>
      </div>
      <p className="login-privacy">
        <FormattedMessage id="AUTH.LOGIN.PRIVACY" />
      </p>
    </LoginWrapper>
  );
};
